module.exports = __webpack_public_path__ + "media/images/partners/culture2025-953d97df526f4fb3cf5871967509ed7f.svg";